import IconButton from "@mui/material/IconButton";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import { Box, Grid, Typography } from "@mui/material";
import Close from "@mui/icons-material/Close";

import "../styles.css";
import { useApp } from "../../../hooks/useApp";
import { CustomButton } from "../../Common/CustomButton";
import { ArrowForward } from "@mui/icons-material";

export default function BubbleCard({
  title,
  id,
  color,
  size,
  top,
  bgColor,
  left,
  index,
  handleClick,
}) {
  return (
    <Grid
      data-id={id}
      className="bubble"
      data-category="supply"
      onClick={handleClick}
      style={{
        backgroundColor: bgColor,
        width: size,
        height: size,
        top: top,
        left: left,
        zIndex: index,
      }}
    >
      <Grid className="bubble-content">
        <Typography component="h3" style={{ color: color }}>
          {title}
        </Typography>
      </Grid>
    </Grid>
  );
}

// Keep ExpandedBubble + AppCard exported for parent use
export function ExpandedBubble({
  title,
  description,
  library,
  handleClose,
}) {
  return (
    <Grid className="w-full">
      <Box className="flex justify-between bubble_header gap-2 mb-1">
        <Box>
          <Typography component="h4" style={{ color: "#fff" }}>
            {title}
          </Typography>
          <Typography component="p" style={{ color: "#fff" }}>
            {description}
          </Typography>
        </Box>

        <IconButton
          className="!bg-[#ffffff29] p-2 !rounded-lg !h-9 !w-9"
          onClick={handleClose}
        >
          <Close className="!h-6 !w-6" />
        </IconButton>
      </Box>

      <Box className="appCard_list">
        {library?.map((app, index) => (
          <AppCard key={index} app={app} />
        ))}
      </Box>
    </Grid>
  );
}

export function AppCard({ app }) {
  const { setActiveVideo } = useApp();

  const handleVideo = (url) => {
    setActiveVideo(url);
  };

  const handleOpenLibrary = (libraryUrl) => {
    window.open(libraryUrl, "_blank");
  };

  return (
    <Box className="image_card">
      <Box className="relative image_box">
        {app?.video && (
          <IconButton
            onClick={() => handleVideo(app.video)}
            style={{
              opacity: 1,
              width: 50,
              height: 50,
              zIndex: 5,
              position: "absolute",
              left: "50%",
              top: "50%",
              transform: "translate(-50%,-50%)",
            }}
          >
            <PlayCircleIcon style={{ opacity: 1, width: 60, height: 60 }} />
          </IconButton>
        )}
        <img src={app?.img || app?.image} alt="" />
      </Box>

      <Box className="flex flex-col w-full gap-1 justify-between h-full">
        <Box>
          <Typography
            component="h5"
            className="app-name text-left"
            style={{ color: "#fff" }}
          >
            {app?.name}
          </Typography>
          <Typography
            component="p"
            className="app-name text-left font-normal"
            style={{ color: "#fff" }}
          >
            {app?.description}
          </Typography>
        </Box>

        <CustomButton
          variant="contained"
          color="secondary"
          size="small"
          onClick={() => handleOpenLibrary(app?.url)}
          endIcon={<ArrowForward />}
        >
          Go to Library
        </CustomButton>
      </Box>
    </Box>
  );
}
